import { HStack, Spacer, VStack } from '@sgme/ui';
import { useCallback, useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { NegociationList } from '@/App/VoiceTimestamping/NegociationList.tsx';
import { useTrackEvent } from '@/App/VoiceTimestamping/useTrackEvent.ts';
import { nonReduxStateContext } from '@/context/nonReduxStateContext';

//
// honoring Mifid2 regulation
//

export const VoiceTimestampingPanel = () => {
  const trackEvent = useTrackEvent();

  const { showVoiceTimestampingPanel, setShowVoiceTimestampingPanel } = useContext(nonReduxStateContext);

  const handleClose = useCallback(() => {
    setShowVoiceTimestampingPanel(false);
    trackEvent('Close Mifid2 panel');
  }, [setShowVoiceTimestampingPanel]);

  // The enclosing div ensures that the children are still in the vdom tree when the panel is closed
  // so that the state survives to the panel closing.

  return (
    <div className="h-100 bg-lvl1 p-3" style={{ width: 340, display: showVoiceTimestampingPanel ? 'block' : 'none' }}>
      <VStack className="h-100 overflow-y-auto" style={{ scrollbarWidth: 'thin' }} flex="min" verticalAlignment="start">
        <HStack>
          <FormattedMessage tagName="h5" id="voiceTimestamping.panel.title" />
          <Spacer />
          <button type="button" className="btn btn-discreet btn-icon btn-flat-primary" onClick={handleClose}>
            <span className="icon">close</span>
          </button>
        </HStack>
        <p className="text-secondary">
          <FormattedMessage id="voiceTimestamping.panel.intro" />
        </p>
        <NegociationList />
      </VStack>
    </div>
  );
};
